import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuToggle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 23,
			height: 23,
			rx: "var(--menu-toggle-radius, 4.5)",
			fill: "#122C30"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 23,
			height: 23,
			rx: "var(--menu-toggle-radius, 4.5)",
			stroke: "url(#paint0_linear_8849_740)",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 8L7.5 12L11.5 16",
			stroke: "#79FBAF",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M15.5 8L11.5 12L15.5 16",
			stroke: "#79FBAF",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_8849_740",
			x1: 24,
			y1: 6.28742,
			x2: 8.36283,
			y2: 6.96706,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#54866C" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#245060"
			})]
		}) })
	]
});
export default SvgMenuToggle;
